import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NegocioAvComponent } from './negocio-av.component';


@NgModule({
  declarations: [
    NegocioAvComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    NegocioAvComponent
  ]
})
export class NegocioAvModule { }
